import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { appRoutes } from '../../../common/appRoutes'

/**
 * For backwards compatibility of routing.
 */
export const MoySkladAccountSettingsOldRoute =
  () => {
    const redirects = [
      {from: 'status', to: 'status'},
      {from: 'products', to: 'products'},
      {from: 'orders', to: 'orders'},
      {from: 'configuration', to: 'settings'},
      {from: 'additional', to: 'attributes'},
      {from: 'syncLogs', to: 'syncLogs'}
    ] as const satisfies readonly {
      from: keyof typeof appRoutes.MoySkladOld.settings
      to: keyof typeof appRoutes.MoySklad
    }[]

    return <>
      <Switch>
        {
          redirects.map(({from, to}) =>
            <Route key={from} path={appRoutes.MoySkladOld.settings[from].template}>
              <Redirect to={appRoutes.MoySklad[to]}/>
            </Route>)
        }

        <Route path={appRoutes.MoySkladOld.settings.template}>
          <Redirect to={appRoutes.MoySklad.orders}/>
        </Route>

        {/* NOTE: Fallback route, must remain the last one */}
        <Route path="*">
          <Redirect to={appRoutes.MoySklad.settings}/>
        </Route>
      </Switch>
    </>
  }